<div class="backModal enCalendar">
  <div class="close closeModal">
    <a (click)="close()" title="cerrar">
      <span class="cross"></span>
      <span class="sr-only">cerrar</span>
    </a>
  </div>
  <div class="aviso">
    <div class="tituloSearch">{{ 'MOTIVO_DEVOLUCION' | translateV2 }}</div>
    
    <div class="avisoInputWrap" [formGroup]="motivoForm">
      <div class="instruccion-texto">
        {{ 'DETERMINE_MOTIVO_DEVOLUCION' | translateV2 }}
      </div>
      
      <div class="form-group">
        <select formControlName="motivoSeleccionado" class="form-control">
          <option value="">{{ 'SELECCIONE_MOTIVO' | translateV2 }}</option>
          <option *ngFor="let motivo of motivos" [value]="motivo.pkid">
            {{ motivo.nombre }}
          </option>
        </select>
      </div>
      
      <div *ngIf="esObligatorio && !motivoForm.get('motivoSeleccionado')?.value" class="error-message">
        {{ 'DEBE_SELECCIONAR_MOTIVO' | translateV2 }}
      </div>
    </div>
    
    <div class="faturacion-fila">
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" class="cancelar" (click)="cancelar()">
            {{ 'CANCELAR' | translateV2 }}
          </button>
        </div>
      </div>
      <div class="ticket-info">
        <div class="inputControl botones">
          <button type="button" class="pagar aceptar" (click)="aceptar()">
            {{ 'ACEPTAR' | translateV2 }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>